import { Box, Button, ButtonGroup, Card, CardActions, CardContent, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { TooltipRenderProps } from 'react-joyride'

const useStyles = makeStyles({
  root: {
    minWidth: 350,
    maxWidth: 350,
  },
})

export function JoyrideTooltip({
  index,
  continuous,
  primaryProps,
  skipProps,
  tooltipProps,
  step,
  closeProps,
  backProps,
  size,
}: TooltipRenderProps) {
  const classes = useStyles()
  return (
    <Card {...tooltipProps} className={classes.root}>
      <CardContent>
        <Typography variant="h6" color="textPrimary" gutterBottom>
          {step.content}
        </Typography>
      </CardContent>
      <CardActions>
        <Box width="100%" display="flex" justifyContent="space-between">
          <Button {...skipProps} variant="outlined">
            {closeProps.title}
          </Button>
          <ButtonGroup>
            {index > 0 && (
              <Button variant="outlined" color="primary" {...backProps}>
                {backProps.title}
              </Button>
            )}
            {continuous && (
              <Button variant="contained" color="primary" {...primaryProps}>
                {`${primaryProps.title} ( ${index + 1} / ${size} )`}
              </Button>
            )}
          </ButtonGroup>
        </Box>
      </CardActions>
    </Card>
  )
}
